














import { defineComponent, computed } from '@vue/composition-api';

const CommonDistrictSelector = defineComponent({
  setup(props: any) {
    const itemsId = computed(() => {
      if (!props.list) return [];
      const temp: string[] = [];
      props.list.forEach((item: any) => {
        temp.push(item.id);
      });
      return temp;
    });
    const itemsName = computed(() => {
      if (!props.list) return [];
      const temp: string[] = [];
      props.list.forEach((item: any) => {
        temp.push(item.nameInThai);
      });
      return temp;
    });

    const district = computed(() => {
      if (!props.list) return [undefined];
      const temp = props.list.find((item: any) => item.id === props.value);
      return (temp && 'districts' in temp) ? temp.districts : [];
    });

    const _value = computed(() => props.value);

    return {
      itemsId,
      itemsDisplay: itemsName,
      district,
      _value,
    };
  },
  props: {
    level: {},
    label: {
      type: String,
      default() { return 'อำเภอ/เขต'; },
    },
    value: {
      type: String,
      default() { return ''; },
    },
    list: {
      type: Array,
      default() { return ['โปรดเลือกจังหวัด']; },
    },
    showLabel: { default: false },
    rules: { default: '' },
  },
});

export default CommonDistrictSelector;
